export default __webpack_public_path__ + "static/media/img1.43c05be1.png";